import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { getDealerInfoAPI } from './state/actions';
import {
    InfoContainer,
    ContainerTitle,
    InfoBodyContainer,
    ToolTipContainer,
    ToolTipText,
    HoursContainer, HourContainer, DayContainer, Day2Container, IconContainer
} from './styles';
import  TooltTip from 'components/ToolTip'
import { ToolTipDirection } from 'components/ToolTip'
import { TCButton } from 'components/TCButton';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { SectionWrapper } from 'common/baseComponents';
import { SIZE } from 'common/sizes';
import { ReactComponent as IconHours } from 'common/images/icon-hours.svg'
import { ReactComponent as IconWeb } from 'common/images/icon-web.svg'
import { ReactComponent as IconLocation } from 'common/images/icon-location.svg'
import { ReactComponent as IconInfo } from 'common/images/icon-info.svg'
import { ReactComponent as IconPhone } from 'common/images/icon-phone.svg'
import { ReactComponent as IconDescription } from 'common/images/icon-description.svg'
import { Loader } from 'components/Loader'
import { serviceLoading } from 'common/loaderReducer';
import { GET_DEALERINFO_API_REQUEST } from 'features/Dealers/Listings/Info/state/actionTypes';
import { updateSelectedDealer } from 'features/Dealers/DealerSelect/state/actions';

const DealerInfo = (props: any) => {
    const dispatch = useDispatch();

    const rootProps = useSelector((rootState: RootState) => {
        return {
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            info: rootState.dealers.listing.currentListing.info.info,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            isLoadingDealerInfo: serviceLoading(rootState, [GET_DEALERINFO_API_REQUEST])
        }
    }, shallowEqual);


    React.useEffect(() => {
        if (rootProps.selectedListingId && rootProps.selectedListingId != "") {
            dispatch(getDealerInfoAPI(rootProps.selectedListingId))
        }
    }, [rootProps.selectedListingId])


    React.useEffect(() => {
        if (!rootProps.isLoadingDealerInfo && rootProps.selectedDealer) {                    
            dispatch(updateSelectedDealer(rootProps.selectedDealer.id))        
        }
    }, [rootProps.isLoadingDealerInfo])



    if (rootProps.info && !rootProps.isLoadingDealerInfo && rootProps.selectedListingId && rootProps.selectedListingId != "") {
        return (
            <InfoContainer>
                <ContainerTitle>
                    As appears in CMS
                        <TooltTip
                        renderIcon={renderIcon}
                        renderBody={renerToolTipBody}                       
                    />
                </ContainerTitle>
                <InfoBodyContainer>
                    <SectionWrapper margin={`4px 0`}>
                        <InputIconField
                            value={rootProps.info?.adress + " " + rootProps.info?.city + "," + rootProps.info?.state + "," + rootProps.info?.zipcode}
                            readonly={true}
                            renderIcon={() => { return (<IconContainer><IconLocation /></IconContainer>) }}
                            onActionClick={(action: InputIconFieldAction) => { }}
                        />
                    </SectionWrapper>
                    <SectionWrapper margin={`4px 0`}>
                        <InputIconField
                            value={rootProps.info?.url}
                            readonly={true}
                            renderIcon={() => { return (<IconContainer><IconWeb /></IconContainer>) }}
                            onActionClick={(action: InputIconFieldAction) => { }}
                        />
                    </SectionWrapper>
                    <SectionWrapper margin={`4px 0`}>
                        <InputIconField
                            value={rootProps.info?.phone}
                            readonly={true}
                            renderIcon={() => { return (<IconContainer><IconPhone /></IconContainer>) }}
                            onActionClick={(action: InputIconFieldAction) => { }}
                        />
                    </SectionWrapper>
                    <SectionWrapper margin={`4px 0`}>
                        <InputIconField
                            readonly={true}
                            renderIcon={() => { return (<IconContainer><IconHours /></IconContainer>) }}
                            renderValue={renderValueForHours}
                        />
                    </SectionWrapper>
                </InfoBodyContainer>
            </InfoContainer>
        )


    }
    else {
        return (
            <InfoContainer>
                <Loader></Loader>
            </InfoContainer>
        )
    }

    function renderIcon() {
        return (
            <IconContainer>
                <IconInfo />            
            </IconContainer>
        )
    }

    function renerToolTipBody() {
        return (
            <ToolTipContainer>
                <ToolTipText>
                    {`To edit the information in this \nsection, please return to the CMS`}
                </ToolTipText>
                <TCButton
                    type={TC_BUTTON_TYPE.PRIMARY}
                    onClick={() => {
                        if (rootProps.info?.cms)
                            window.location.href = rootProps.info.cms;
                    }}
                >
                    Back to CMS
                </TCButton>
            </ToolTipContainer>
        )
    }

    function renderValueForHours(state: InputIconFieldState) {
        return (
            <HoursContainer>
                {
                    rootProps.info?.infoHours.map(day => {
                        return (
                            <HourContainer key={day.day}>
                                <DayContainer>
                                    {
                                        day.day
                                    }
                                </DayContainer>
                                <Day2Container>
                                    {
                                        day.formattedHour
                                    }
                                </Day2Container>
                            </HourContainer>
                        )
                    })
                }
            </HoursContainer>
        )

    }


}

export default DealerInfo;